<template>
  <div class="home">
    <div class="header">
      <el-form label-position="left">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="赛季名称">
              <el-select @change="getRace" v-model="season" placeholder="请选择赛季">
                <el-option v-for="item in seasons" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="比赛日期">
              <el-date-picker @change="getRace" v-model="date" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <h4 v-show="getNowSeason">举办马场：{{getNowSeason}}</h4>
      </el-row>
    </div>
    <div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="赛事列表" name="races"></el-tab-pane>
        <el-tab-pane label="练马师分场表" name="trainers"></el-tab-pane>
        <el-tab-pane label="骑师分场表" name="jockeys"></el-tab-pane>
      </el-tabs>
      <div class="content">
        <el-table v-show="activeName === 'races'" :data="races" style="width: 100%" empty-text="今日暂无比赛数据，可切换比赛日">
          <el-table-column type="expand">
            <template slot-scope="props">
              <horse-list inline :list="props.row.players"></horse-list>
            </template>
          </el-table-column>
          <el-table-column label="赛事名称" prop="name">
          </el-table-column>
          <el-table-column label="开赛时间" prop="time">
          </el-table-column>
          <el-table-column label="参赛马匹总数" prop="players.length">
          </el-table-column>
        </el-table>
        <player-table v-show="activeName === 'trainers'" thPlayerName="练马师" :list="trainers" :header="baseRaces" :races="baseRacesInfo" indexName="trainerName"></player-table>
        <player-table v-show="activeName === 'jockeys'" thPlayerName="骑师" :list="jockeys" :header="baseRaces" :races="baseRacesInfo" indexName="jockeyName"></player-table>
      </div>
    </div>
  </div>
</template>

<script>
  import {getRaceList, getSeasons} from "@/api/home";
  import {formatDate} from "@/utils/formatDate";
  import HorseList from "@/components/HorseList/index";
  import PlayerTable from "@/components/PlayerTable/index";
  import {groupBy} from "@/utils/groupBy";

  export default {
    name: 'Home',
    components: {
      HorseList,
      PlayerTable
    },
    created() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.76)'
      });
      this.getSeasons().then(() => {
        this.getRace().then(() => {
          loading.close();
          this.canReLoad = true; // 完成初次加载
        })
      });
    },
    data () {
      return {
        activeName: 'races',
        canReLoad: false,
        seasons: [],
        season: null,
        date: new Date(),
        tableData: null,
        races: null,
        jockeys: null,
        trainers: null,
        baseRaces: null,
        baseRacesInfo: null
      };
    },
    computed: {
      getNowSeason() {
        for(const item of this.seasons) {
          if(item.id === this.season) {
            return item.groundName
          }
        }
      }
    },
    methods: {
      async getRace () {
        await this.getRacesBySeasonId(this.season, this.date)
      },
      async getSeasons() {
        const { data } = await getSeasons({conditions: {
            withoutRaces: 1
          },
          current: 1,
          orderBys: [],
          reverse: false,
          size: 100});
        const {records} = data;
        this.seasons = records;
        if(!this.season) this.season = records[0].id;
      },
      async getRacesBySeasonId (id, time) {
        let loading;
        if (this.canReLoad) {
          loading = this.$loading({
            lock: true,
            text: '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(255,255,255,0.76)'
          });
        }
        if (!time) time = new Date();
        const et = formatDate(time, 'yyyy-MM-dd 23:59:59');
        time = formatDate(time, 'yyyy-MM-dd 00:00:00');
        const reqParams = {
          st: time,
          et: et,
          data: {
            seasonID: id
          }
        };
        const {data} = await getRaceList(reqParams);
        data.sort((a, b)=> {
          return Date.parse(a.time) - Date.parse(b.time);
        });
        for(const item of data) {
          item.time = formatDate(new Date(item.time), 'HH:mm')
        }
        this.tableData = data;
        this.races = data;
        const baseArr = (() => {
          const arr = [];
          const raceArr = [];
          for (const item of this.races) {
            arr.push(item.id)
            raceArr.push({
              id: item.id,
              name: item.name,
              time: item.time
            })
          }
          return [arr, raceArr];
        })();
        this.baseRaces = baseArr[0];
        this.baseRacesInfo = baseArr[1];
        const players = this.formatPlayers(data);
        const trainers = groupBy(players, (item) => {
          return [item.trainerId];
        });
        this.trainers = (()=>{
          const arr = [];
          for(const item of trainers) {
            const obj = {};
            obj.trainerName = item[0].trainerName;
            obj.trainerId = item[0].trainerId;
            obj.races = this.formatRaces(item, 'trainerId');
            arr.push(obj);
          }
          return arr;
        })();
        const jockeys = groupBy(players, (item) => {
          return [item.jockeyId];
        });
        this.jockeys = (()=>{
          const arr = [];
          for(const item of jockeys) {
            const obj = {};
            obj.jockeyName = item[0].jockeyName;
            obj.jockeyId = item[0].jockeyId;
            obj.races = this.formatRaces(item, 'jockeyId');
            arr.push(obj);
          }
          return arr;
        })();
        if (this.canReLoad) {
          loading.close()
        }
      },
      formatPlayers(data) {
        const playersArr = [];
        for(const item of data) {
          let { players } = item;
          if (players && players.length > 0) {
            for (let i = 0; i < players.length; i++) {
              players[i].raceInfo = { raceName: item.name, raceId: item.id };
              playersArr.push(players[i]);
            }
          }
        }
        return playersArr;
      },
      formatRaces: function (list, type) {
        const sId = list[0][type];
        const reArr = [];
        const baseRaces = this.baseRaces;
        const listIds = (() => {
          const arr = [];
          for (const item of list) {
            const { raceInfo } = item;
            arr.push(raceInfo.raceId);
          }
          return arr;
        })();
        for (const item of baseRaces) {
          if (!this.isInArray(listIds, item)) {
            reArr.push({
              id: item,
              isNull: true
            })
          } else {
            reArr.push({
              id: item,
              isNull: false,
              horseList: this.getHorseListByRaceId(item, sId, type)
            })
          }
        }
        return reArr;
      },
      isInArray(arr,value){
        for(let i = 0; i < arr.length; i++){
          if(value === arr[i]){
            return true;
          }
        }
        return false;
      },
      getHorseListByRaceId(raceId, playerId, type) {
        const arr = [];
        for (const item of this.tableData) {
          if (raceId === item.id) {
            if (item.players && item.players.length > 0) {
              for (const itemT of item.players) {
                if (itemT[type] === playerId) {
                  arr.push(itemT)
                }
              }
            }
          }
        }
        return arr
      }
    }
  }
</script>
<style scoped>
  .home {
    padding: 1rem;
  }
</style>